export const RANDOM_CHAR_POOL = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

export function randomString(length: number) {
  return Array.from(Array(length))
    .map(() => RANDOM_CHAR_POOL[Math.floor(Math.random() * RANDOM_CHAR_POOL.length)])
    .join("");
}
